import { useMemo } from 'react'
import { useRouteMatch } from '../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { GridNode } from '../common/shared/grid-item'
import { TemplateMenu } from '../common/menu/node-actions'
import { IconTemplate } from '../../../../../shared/icon/icon'
import { PlatformIcons } from '../common/platform/platform-controls'
import { NodeUpdated } from '../common/shared/node-updated'

export const NodeTemplateGridItem = ({ node, dataContext }) => {
  const { url } = useRouteMatch()

  const to = useMemo(() => `${url}/template/${node.id}/edit`, [url, node])

  const FooterMenu = () => <TemplateMenu place="card" url={`${url}/template/${node.id}`} node={node} />

  // Where a course made from it runs (content's `platforms`). The same
  // component from render to render, so its list stays open while the
  // grid's thumbnails arrive.
  const platforms = node.platforms
  const Badges = useMemo(() => () => <PlatformIcons platforms={platforms} unpublished card />, [platforms])
  // When a build of it last became available, else when it was created.
  const Detail = () => <NodeUpdated node={node} />

  return <GridNode Icon={IconTemplate} FooterMenu={FooterMenu} Badges={Badges} Detail={Detail} node={node} to={to} dataContext={dataContext} />
}
